import { render, staticRenderFns } from "./tilda_export.vue?vue&type=template&id=107e1148&scoped=true&"
import script from "./tilda_export.vue?vue&type=script&lang=js&"
export * from "./tilda_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107e1148",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107e1148')) {
      api.createRecord('107e1148', component.options)
    } else {
      api.reload('107e1148', component.options)
    }
    module.hot.accept("./tilda_export.vue?vue&type=template&id=107e1148&scoped=true&", function () {
      api.rerender('107e1148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/tilda/tilda_export.vue"
export default component.exports